import { MouseEvent, ReactElement, ReactNode } from 'react';
import { TooltipArrowPlacement } from './tooltipArrow';

type CursorType = 'default' | 'pointer';

export type TooltipProps = {
  children?: ReactNode;
  title: string | ReactElement;
  cursorType?: CursorType;
  className?: string;
  mode?: TooltipModeModel;
};

export type UseTooltipPositionOutput = {
  position: TooltipPosition;
  arrowPlacements: TooltipArrowPlacement;
  handleMove: (e: MouseEvent) => void;
};

export type UseTooltipTogglingOutput = {
  isOpen: boolean;
  handleOpen: (e: MouseEvent) => void;
  handleClose: (e: MouseEvent) => void;
};

export type TooltipPosition = {
  left: number;
  top: number;
};

export enum TooltipMode {
  white = 'white',
  dark = 'dark',
}

export type TooltipModeModel = keyof typeof TooltipMode;

export type TooltipStyledProps = {
  isOpen: boolean;
  mode: TooltipModeModel;
} & TooltipPosition;
export type TooltipContainerStyledProps = {
  cursorType: CursorType;
};

export type MousePosition = {
  x: number;
  y: number;
};
